
import { DomainsKeys } from '../../external-configuration';

import Call, { buildApiBasePath } from './Base';

const PublicPath = '/public';
const MessagePath = `${PublicPath}/message`;
const UserchatPath = `${PublicPath}/userchat`;

export function loadMessages( chatId) {
  const uri = `${buildApiBasePath(DomainsKeys.CMS)}${MessagePath}/filter/${chatId}`;
  const options = {
    uri,
  };

  return Call.get( uri, options);
}

export function publishMessage( chatId, sessionToken, text, userName) {
  const uri = `${buildApiBasePath(DomainsKeys.CMS)}${MessagePath}/${chatId}`;
  const options = {
    uri,
    headers: {
      'x-access-token': sessionToken,
    },
    body: {
      sessionToken,   // redundante?
      text,
      userName,
    },
  };

  return Call.post( uri, options);
}

export function login( chatId, mail, password) {
  const uri = `${buildApiBasePath(DomainsKeys.CMS)}${UserchatPath}/login/${chatId}`;
  const options = {
    uri,
    body: {
      mail,
      password,
    },
  };

  return Call.post( uri, options);
}

export function register( chatId, name, userName, password, mail) {
  const uri = `${buildApiBasePath(DomainsKeys.CMS)}${UserchatPath}/${chatId}`;
  const options = {
    uri,
    body: {
      name,
      userName,
      password,
      mail,
    },
  };

  return Call.post( uri, options);
}

export function resendActivationToken( chatId, mail) {
  const uri = `${buildApiBasePath(DomainsKeys.CMS)}${UserchatPath}/activate/${chatId}`;
  const options = {
    uri,
    body: {
      mail,
    },
  };

  return Call.post( uri, options);
}

export function resetPassword( chatId, location, mail) {
  const uri = `${buildApiBasePath(DomainsKeys.CMS)}${UserchatPath}/password/${chatId}`;
  const options = {
    uri,
    body: {
      location,
      mail,
    },
  };

  return Call.post( uri, options);
}

export function changePassword( chatId, sessionToken, password) {           // x-access-token
  const uri = `${buildApiBasePath(DomainsKeys.CMS)}${UserchatPath}/password/${chatId}`;
  const options = {
    uri,
    headers: {
      'x-access-token': sessionToken,
    },
    body: {
      sessionToken,   // redundante?
      password,
    },
  };

  return Call.put( uri, options);
}

export function socialLogin( chatId, userName, socialId, mail, socialNetwork) {
  const uri = `${buildApiBasePath(DomainsKeys.CMS)}${UserchatPath}/socialLogin/${chatId}`;
  const options = {
    uri,
    body: {
      userName,
      socialId,
      mail,
      socialNetwork,
    },
  };

  return Call.post( uri, options);
}
